import AnnouncementsManagerDashboard from './AnnouncementManagerDashboard';

export default AnnouncementsManagerDashboard;
